import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'dynamicDNCUploads',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'DNC Dynamic Uploads',
  },
}

const keys = {
  statKey: 'posted_dnc_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const dynamicDNCUploads = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { dynamicDNCUploads }
